import { COMPONENT_STATES, COMPONENT_TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock, CreationContextFor } from '../creation-types';

export const smsLogin = ({
	dictionary,
}: CreationContextFor<typeof COMPONENT_TYPE.SMS_LOGIN>): CreatedBuildingBlock<typeof COMPONENT_TYPE.SMS_LOGIN> =>
	createModel({
		type: COMPONENT_TYPE.SMS_LOGIN,
		componentProps: {
			other: {},
			styles: {},
		},
		children: {
			[COMPONENT_STATES.DEFAULT]: {
				[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: dictionary.SMS_LOGIN.label,
			},
		},
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.SMS_LOGIN>;
